import { Injectable, signal, WritableSignal } from '@angular/core';
import { Subject } from 'rxjs';
import { FieldTree, form, SchemaFn } from '@angular/forms/signals';


@Injectable()
export abstract class AbstractSignalForm<K extends string, M> {
    #model: WritableSignal<M>;

    public form: FieldTree<M>;

    protected createFormModel(model: M): void{
        this.#model = signal<M>(model);
    }

    private destroy$: Subject<void> = new Subject<void>();

    public ngOnDestroy(): void {
        this.destroy();
    }

    public destroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }

    public patch(data: M): void {
        this.#model.set(data);
    }

    protected build(schema?: SchemaFn<M>): void {
        this.form = form(this.#model, schema || null);
    }

    public abstract createSignalForm(): FieldTree<M>;

}
